import {
    Blueness
} from "../map-config.js";
export default {
    props: {
        lng: {
            default () {
                return '105.403119';
            }
        },
        lat: {
            default () {
                return '38.028658';
            }
        },

        scale: {
            default () {
                return 1;
            }
        },
        mapStyle: {
            default () {
                return Blueness;
            }
        },
        isLabelText: {
            type: Boolean,
            default: true
        },
        showMap: {
            type: Boolean,
            default: true
        },
        zoom: {
            type: Number,
            default () {
                return 5;
            }
        },
        zoomMin: {
            type: Number,
            default () {
                return 5;
            }
        },
        zoomMax: {
            type: Number,
            default () {
                return 19;
            }
        },
        //工具条
        zoomTool: {
            type: Boolean,
            default: true
        },
        //鼠标放大
        mouseZoom: {
            type: Boolean,
            default: true
        },
        //地图拖拽
        drag: {
            type: Boolean,
            default: true
        }
    }
}